import * as Sentry from '@sentry/react';
import { InvoiceEvidenceView } from '../../../types/entity-types';
import { exhaustiveCheck } from '../../../utils/exhaustive-check';
import { getBillPayFlow } from '../../payments/bill-pay-flow/utils/get-bill-pay-flow';
import { BeneficiaryCardConfig } from '../components/invoice-drawer/invoice-drawer-content-body';

export const getBeneficiaryCardConfig = (evidence: InvoiceEvidenceView): BeneficiaryCardConfig => {
  // Beneficiary card display logic and bill pay flow logic should match, that is why we use getBillPayFlow here
  const billPayFlow = getBillPayFlow(evidence);

  switch (billPayFlow) {
    case 'KNOWN_BENEFICIARY': {
      if (!evidence.suggestedBeneficiary) {
        Sentry.captureMessage(
          'Evidence with suggestedBeneficiaryId does not have a linked suggestedBeneficiary in getBeneficiaryCardConfig',
          {
            extra: {
              evidenceId: evidence.id,
              suggestedBeneficiaryId: evidence.suggestedBeneficiaryId,
              billPayFlow,
              message:
                'Evidence with suggestedBeneficiaryId does not have a linked suggestedBeneficiary in getBeneficiaryCardConfig',
            },
          },
        );

        return {
          isVisible: false,
        };
      }

      return {
        isVisible: true,
        variantConfig: 'SUGGESTED_BENEFICIARY' as const,
        beneficiaryType: evidence.suggestedBeneficiary.destination.type,
        name: evidence.suggestedBeneficiary.name,
        currency: evidence.suggestedBeneficiary.destination.currency,
        iban: evidence.suggestedBeneficiary.destination.iban,
        accountNumber: evidence.suggestedBeneficiary.destination.accountNumber,
        sortCode: evidence.suggestedBeneficiary.destination.sortCode,
      };
    }
    case 'KNOWN_DESTINATION_BENEFICIARY_DOES_NOT_EXIST':
      if (!evidence.vendorInformation?.vendorCompanyName) {
        return {
          isVisible: false,
        };
      }

      return {
        isVisible: true,
        variantConfig: 'NEW_BENEFICIARY' as const,
        name: evidence.vendorInformation.vendorCompanyName,
      };
    case 'UNKNOWN_BENEFICIARY':
      return {
        isVisible: false,
      };
    default:
      return exhaustiveCheck(billPayFlow);
  }
};
